import axios from 'axios'
import store from './../store'
import { setAuthenticated } from '../store/reducers/userReducer'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

export const request = async function <T>(options: any): Promise<T> {
  return client({ withCredentials: true, ...options }).then((response) => response.data)
}

client.interceptors.response.use(
  (res) => {
    // success
    return res
  },
  (err) => {
    const status = err?.response?.status
    if (status === 401) store.dispatch(setAuthenticated(false))
    return Promise.reject(err)
  },
)

export default request
